  // Converting numbers with comma separated
  export default  function numberWithCommas(x:any) {
    x = x?.toString();
    const pattern = /(-?\d+)(\d{3})/;
    while (pattern.test(x))
        x = x.replace(pattern, "$1,$2");
    return x;
}